import React from 'react';
import {
  LatestProjectReviewCard,
  LatestProjectReviewImage,
  LatestProjectReviewButton,
  LatestProjectReviewDateTime,
  LatestProjectReviewDescription,
  LatestProjectReviewDetail,
  LatestProjectReviewTitle,
} from './LatestProjectReviewCard.style';
import { LatestReviewPost } from '../../queries/contentPage/postDetail';
import dateTimeHelper from '../../common/helpers/ui/DateTimeHelper';

export const LatestProjectCard = (
  props: LatestReviewPost | null,
): React.ReactElement => {
  const {
    title,
    date,
    link,
    featuredImage: { url = '', title: alt = '' } = {},
  } = props;

  if (props === null || !title) return null;

  return (
    <LatestProjectReviewCard id="lastestProjectReviewCard">
      <LatestProjectReviewImage src={url} alt={alt} />
      <LatestProjectReviewDetail>
        <LatestProjectReviewTitle>รีวิวโครงการ</LatestProjectReviewTitle>
        <LatestProjectReviewDescription>{title}</LatestProjectReviewDescription>
        <LatestProjectReviewDateTime>
          {dateTimeHelper.getCustomDateTime(date, 'D MMMM YYYY')}
        </LatestProjectReviewDateTime>
      </LatestProjectReviewDetail>
      <LatestProjectReviewButton href={link}>
        อ่านรีวิวล่าสุด
      </LatestProjectReviewButton>
    </LatestProjectReviewCard>
  );
};
